import React from 'react';
import './_admissionForms.scss';

const StudentFormSuccess = ({ name }) => {
  return (
    <div className="form-success-wrapper">
      <div className="form-success-card">
        <img
          src="/images/successconfirmation.svg"
          alt="success"
          className="success-img"
        />
        <h2>Thank You, {name}! 🎉</h2>
        <p>Your enquiry has been submitted successfully.</p>
        <p className="sub-text">
          Our team will contact you on your registered mobile number shortly.
        </p>
      </div>
    </div>
  );
};

export default StudentFormSuccess;
